import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { delay: { type: Number, default: 275 } }

  connect() {
    this.timer = null
  }

  disconnect() {
    window.clearTimeout(this.timer)
  }

  queue(event) {
    if (event.isComposing) return

    window.clearTimeout(this.timer)
    this.timer = window.setTimeout(() => this.element.requestSubmit(), this.delayValue)
  }

  start() {
    this.element.classList.add("is-searching")
  }

  finish() {
    this.element.classList.remove("is-searching")
  }

  syncUrl() {
    const url = new URL(this.element.action, window.location.origin)
    const query = new URLSearchParams()

    for (const [key, value] of new FormData(this.element).entries()) {
      if (typeof value === "string" && value.length > 0) query.append(key, value)
    }

    url.search = query.toString()
    window.history.replaceState(window.history.state, "", `${url.pathname}${url.search}${url.hash}`)

    const exportLink = document.querySelector("[data-admin-directory-export]")
    if (exportLink) {
      const exportUrl = new URL(exportLink.href, window.location.origin)
      exportUrl.search = query.toString()
      exportLink.href = exportUrl.toString()
    }
  }
}
